import React, { useCallback, useEffect, useRef, useState, } from 'react';
import { CircularProgress, Typography } from '@mui/material';
import classNames from 'classnames';
import { StyledLoading } from './loading.styles';
export const ELLIPSES_TIMEOUT = 250;
export function Loading({ iconOrientation = 'bottom', isLoading, label = 'Loading', progressSize = 40, rootClass, showEllipsis = true, showLabel = true, timeout = 0, }) {
    const [ellipses, setEllipses] = useState('');
    const [loading, setLoading] = useState(false);
    const timerRef = useRef(null);
    const ellipsesTimerRef = useRef(null);
    const clearTimers = useCallback(() => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        if (ellipsesTimerRef.current) {
            clearInterval(ellipsesTimerRef.current);
            ellipsesTimerRef.current = null;
        }
    }, []);
    const updateEllipses = useCallback(() => {
        setEllipses((prev) => (prev.length < 3 ? `${prev}.` : ''));
    }, []);
    const showLoading = useCallback(() => {
        setLoading(true);
    }, []);
    const setTimers = useCallback(() => {
        timerRef.current = setTimeout(showLoading, timeout);
        if (showLabel && showEllipsis) {
            ellipsesTimerRef.current = setInterval(updateEllipses, ELLIPSES_TIMEOUT);
        }
    }, [showLabel, showEllipsis, showLoading, updateEllipses, timeout]);
    useEffect(() => {
        // timerRef is always set by setTimers(); ellipsesTimerRef is conditional, so only one ref needs to be checked
        const hasTimers = timerRef.current !== null;
        if (isLoading && !hasTimers) {
            setTimers();
        }
        else if (!isLoading) {
            setLoading(false);
            setEllipses('');
            clearTimers();
        }
        return () => {
            clearTimers();
        };
    }, [isLoading, setTimers, clearTimers]);
    if (!isLoading || !loading) {
        return null;
    }
    return (<StyledLoading className={classNames(iconOrientation, rootClass)}>
      {showLabel && (<Typography variant="caption">
          {label}
          {showEllipsis && ellipses}
        </Typography>)}
      <CircularProgress size={progressSize} aria-label={!showLabel ? label : undefined}/>
    </StyledLoading>);
}
Loading.displayName = 'Loading';
export default Loading;
export function SimpleLoading() {
    return <Loading isLoading/>;
}
